<template>
    <app-layout>
        <template #header>
            <h2 class="h4 font-weight-bold">
                Test Zone
            </h2>
        </template>

    <button @click="getUsers">Get Users</button>
    <button @click="test">Test</button>
    <button @click="loginPayrecon">Login with payrecon</button>

    </app-layout>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout'
    import Button from '../Jetstream/Button.vue'
    
    export default {
        components: {
            AppLayout,
        },
        methods:{
            getUsers(){
                console.log('gggg', route('api.getUser'))
                // let ret = this.$inertia.get(route('api.getUser'), {
                //     onSuccess: (res) => {
                //         console.log(res)
                //     }
                // }, { preserveState: true })
                // console.log(ret)
                fetch(route('api.getUser'))
                    // .then(response => response.json())
                    .then(data => console.log(data));
            },
            test(){
                console.log('gggg', route('api.getUser'))
                // let ret = this.$inertia.get(route('api.getUser'), {
                //     onSuccess: (res) => {
                //         console.log(res)
                //     }
                // }, { preserveState: true })
                // console.log(ret)
                fetch(route('test-api'))
                    // .then(response => response.json())
                    .then(data => console.log(data));
            },
            loginPayrecon(){
                console.log('gggg', route('page.v2-login'))
                // let ret = this.$inertia.get(route('api.getUser'), {
                //     onSuccess: (res) => {
                //         console.log(res)
                //     }
                // }, { preserveState: true })
                // console.log(ret)
                // fetch(route('test-api'))
                    // .then(response => response.json())
                //     .then(data => console.log(data));
                this.$inertia.get(route('page.v2-login'))
                // fetch(route('page.v2-login'))
                //     .then(response => response.json())
                //     .then(data => window.location.href = data.url);
            }
        }
    }
</script>
